module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-800.woff?bde99287fe27e0e3ee89058a0affd4cd";